import END_POINTS from 'common/config/constants/urls';
import { buildPathWithParams } from 'common/helpers/url';
import { toCamelCaseObject } from 'common/helpers/utils';
import { ApiClient } from 'common/services';

export enum WalletTransferStatus {
  PENDING = 'PENDING',
  EXPIRED = 'EXPIRED',
}
export interface WalletTransferInfo {
  status: WalletTransferStatus;
  sourceName: string;
  amount: number;
  currency: string;
  targetMobileNumber: string;
  createdAt: string;
  comment: string;
  country: string;
  sourceProfilePicture: string;
  targetCountry: string;
}
class WalletTransferService {
  static getWalletTransfer = async (token: string) => {
    try {
      const response = await ApiClient.get(
        buildPathWithParams(END_POINTS.getWalletTransfer, { token }),
      );
      return toCamelCaseObject<WalletTransferInfo>(response);
    } catch (error) {
      return Promise.reject(error);
    }
  };

  static sendWrongNumberNotif = async (token: string) => {
    try {
      return await ApiClient.post(buildPathWithParams(END_POINTS.notifyWrongNumber, { token }));
    } catch (error) {
      return false;
    }
  };
}

export default WalletTransferService;
